import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mandae-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

  @Input()
  public get currentPage() {
    return this._currentPage;
  }
  public set currentPage(value: number) {
    this._currentPage = Math.min(Math.max(value, 1), this._pages);
    this.currentPageChange.emit(this._currentPage);

    this.updateDisplayedPages();
  }
  private _currentPage = 1;

  @Output()
  public currentPageChange = new EventEmitter<number>();

  @Input()
  public get currentLimit() {
    return this._currentLimit;
  }
  public set currentLimit(value: number) {
    if (!this.limits.includes(value)) {
      value = this.limits[0];
    }

    this._currentLimit = value;
    this.currentLimitChange.emit(value);
  }
  private _currentLimit = 10;

  @Output()
  public currentLimitChange = new EventEmitter<number>();

  @Input()
  public get pages() {
    return this._pages;
  }
  public set pages(value: number) {
    this._pages = value;
    this.updateDisplayedPages();
  }
  private _pages = 1;

  @Input()
  public limits = [10, 50, 100];

  @Input()
  public displayItems = 7;

  public displayedPages = [];

  constructor() { }

  ngOnInit() {
  }

  private updateDisplayedPages() {
    this.displayedPages = Array.from(Array(7).keys())
      .map((_, x) => x + this.currentPage - Math.ceil(this.displayItems / 2))
      .filter(v => v > 0 && v <= this.pages);
  }

}
